// extracted by mini-css-extract-plugin
module.exports = {"staggerFade":"TemplateMotion_staggerFade__eiy_g","cardFadeIn":"TemplateMotion_cardFadeIn__ErFrk"};